import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { cancelTrip, getCancelCharges } from "redux/actions/OperationsAction";
import { getBookingDetails, getCancelReason } from "redux/actions/ReservationAction";
import { getDateFormat } from "utils/utils";
import Loader from "components/loader/Loader";
import CommonButton from "components/commonButton/CommonButton";

const CancelRegistrationModal = ({
  pageType,
  open,
  toggle,
  reservationData,
  payload,
}) => {
  const dispatch = useDispatch();
  const [cancelReason, setCancelReason] = useState('');
  const cancelReasonList = useSelector((state) => state.getCancelReason?.cancelReason?.data);

  useEffect(() => {
    if (reservationData?.id && pageType !== "bookingDetails") {
      dispatch(getBookingDetails(reservationData?.id));
    }
  }, [reservationData?.id]);

  useEffect(() => {
    dispatch(getCancelReason())
  }, []);

  const reservationDetails = useSelector(
    (state) => state?.getBookingDetails?.bookingDetails
  );
  const reservationDetailsLoader = useSelector(
    (state) => state?.getBookingDetails?.loading
  );

  const chargesResponse = useSelector(
    (state) => state?.cancelationTripCharges?.cancelCharges?.data
  );

  const [checkBoxSelect, setCheckboxSelect] = useState(false);
  const [cancelCharges, setCancelCharges] = useState(false);

  const handleClose = () => {
    setCancelCharges(false);
    setCheckboxSelect(false);
    toggle();
  };

  const handleModal = () => {
    dispatch(getCancelCharges(reservationData?.id, setCancelCharges));
  };

  const handleCancelTrip = () => {
    const data={
      id:reservationData?.id,
      reason:cancelReason
    }
    dispatch(cancelTrip(data, payload, pageType));
    handleClose();
  };

  const handleChange = (e) => {
    setCancelReason(e.target.value)
  }

  const cancelationData = [
    { primaryText: "Company Name -",
      secondaryText: reservationDetails?.companyName
  },
  { primaryText: "Passenger Name -",
      secondaryText: reservationDetails?.customerName
  },
  { primaryText: "Report Address -",
      secondaryText: reservationData?.sourceAddress || reservationData?.sourceLandMarkAddress
  },
  { primaryText: "Reporting Date -",
      secondaryText: getDateFormat(reservationData?.scheduledTime, "date")
  },
  { primaryText: "Report Time -",
      secondaryText: getDateFormat(reservationData?.scheduledTime, "time")
  }
]

const scheduledTime = new Date(reservationData?.scheduledTime);
const currentTime = new Date();
// Comparing two dates and converting into hours format (36e5 is definition of 60*60*1000)
let hrFormat = (scheduledTime.getTime() - currentTime.getTime()) / 36e5;
const totalMinutes = Math.max(hrFormat * 60, 0);  // Convert hours to minutes
const hours = Math.floor(totalMinutes / 60);
const minutes = Math.floor(totalMinutes % 60);
const timeLeft = `${hours > 0 ? hours + ' hr ' : ''}${minutes > 0 ? minutes + ' min' : ''}`;

  return (
    <Modal
      open={open || false}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="customModal"
    >
      <Box>
        {reservationDetailsLoader ? (
          <Loader />
        ) : (
          <>
            {!cancelCharges ? (
              <Box
                className="modalContent cancelModalDetails textLeft"
                sx={{ height: { xs: "100%", sm: "auto" } }}
              >
                <Box className="justifyEnd">
                  <CloseIcon onClick={handleClose} />
                </Box>
                <Box className="modalHeader justifyBetween">
                  <Box className="justifyStart mb20">
                    <Typography
                      variant={"head3"}
                      className="colorPrimary fw600"
                    >
                      Cancel
                      <span className="colorYellow"> Reservation</span>
                    </Typography>
                    <Typography
                      variant={"head5"}
                      className="colorBlack fw600 pl20"
                    >
                      Booking ID - {reservationData?.tripId}
                    </Typography>
                  </Box>
                </Box>
                
                <Box className="mb20">
                <Grid>
                   {cancelationData && cancelationData?.map((data) => (
                    <Grid container className="mb20">
                      <Grid item xs={3}>
                      <Typography variant={"body1"} className="colorGrey">
                        {data?.primaryText}
                      </Typography>
                      </Grid>
                      <Grid container item xs={9}>
                      <Typography variant={"body1"} className="colorBlack">
                        &nbsp;{data?.secondaryText}
                      </Typography>
                      </Grid>
                      </Grid>
                   ))
                   }
                </Grid>
                  <Box className="justifyStart  pt15">
                    <Typography variant={"body1"} className="colorBlack">
                      Reason of cancellation -&nbsp;
                    </Typography>
                    <Box className='width60'>
                      <FormControl fullWidth className="commonFormControl">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          onChange={handleChange}
                          placeholder="Select"
                          displayEmpty
                        >
                          <InputLabel className="colorGrey ml16">
                            <Typography
                              className="colorGrey"
                              variant="body2"
                            >
                              Select Reason
                            </Typography>
                          </InputLabel>
                          {cancelReasonList?.map((item, index) => (
                            <MenuItem value={item?.reason} key={index}>
                              {item?.reason}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  </Box>
                  </Box>
                </Box>
                <CommonButton
                  name="Cancel Reservation"
                  btnClass={"btnLg"}
                  onClick={handleModal}
                  disabled={cancelReason ? false : true}
                />
              </Box>
            ) : (
              <Box
                className="modalContent camcel_modal_charges textLeft"
                sx={{ height: { xs: "100%", sm: "auto" } }}
              >
                <Box className="justifyEnd">
                  <CloseIcon onClick={handleClose} />
                </Box>
                <Box className="modalHeader justifyBetween">
                  <Box className="justifyStart">
                    <Typography
                      variant={"head3"}
                      className="colorPrimary fw600"
                    >
                      Cancel
                      <span className="colorYellow"> Reservation</span>
                    </Typography>
                    <Typography
                      variant={"head5"}
                      className="colorBlack fw600 pl20"
                    >
                      Booking ID - {reservationData?.tripId}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography variant={"body2"} className="ptb10">
                    We appreciate your feedback on this cancellation.
                  </Typography>
                  <Grid container>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      className="mt10 dashedBorderBottom pb10 mb10"
                    >
                      <Grid
                        item
                        xs={6}
                        container
                        alignItems={"flex-start"}
                        flexDirection={"column"}
                      >
                        <Typography variant={"body1"} className="colorBlack mb10">
                          Total fare
                        </Typography>
                        <Typography variant={"body1"} className="colorBlack">
                          Cancellation Fee
                        </Typography>
                        <Typography
                          variant={"body4"}
                          className="textRight colorGrey"
                        >
                           You are cancelling the ride before {timeLeft}
                        </Typography>
                      </Grid>
                      <Grid item container xs={6} justifyContent={"flex-end"}>
                      <Grid item xs={6} flex justifyContent={"center"}>
                        <Typography
                          variant={"body1"}
                          className=" colorBlack"
                        >
                          ₹ {chargesResponse?.totalCharges}
                        </Typography>
                        <Typography
                        variant={"body1"}
                        className=" colorBlack"
                      >
                        ₹ {chargesResponse?.cancellationCharges}
                      </Typography>
                      </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Typography variant={"body1"} className="colorBlack">
                    Are you sure you want to cancel?
                  </Typography>
                  <Typography
                    variant={"body3"}
                    className="textRight colorGrey pb5"
                    component={"p"}
                  >
                    This trip has been offered to a driver right now, and should
                    be confirmed within seconds.
                  </Typography>
                  <FormControlLabel
                    className="mb10"
                    control={
                      <Checkbox
                        checked={checkBoxSelect}
                        onChange={(event) =>
                          setCheckboxSelect(event.target.checked)
                        }
                      />
                    }
                    label={<Typography component="p" variant="body3">I have read and agree to the <Typography className="colorPrimary" variant="body3" component={"span"}>cancellation policy.</Typography></Typography> }
                  />
                  <CommonButton
                    name="Cancel Reservation"
                    btnClass={"btnLg"}
                    disabled={!checkBoxSelect}
                    onClick={handleCancelTrip}
                  />
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default CancelRegistrationModal;
